<template>
  <v-dialog
    :value="value"
    content-class="dialog-wrapper"
    width="700px"
    @input="onInput"
  >
    <div class="dialog">
      <icon-button
        class="close-button"
        @click="onClose"
      >
        <close-icon />
      </icon-button>
      <div class="dialog-content">
        <slot />
      </div>
      <footer
        v-if="!!$slots['left-button'] || !!$slots['right-button']"
        :class="['dialog-footer', {'dialog-footer--center': centerButtons}]"
      >
        <slot name="left-button" />
        <slot name="middle-button" />
        <slot name="right-button" />
      </footer>
    </div>
  </v-dialog>
</template>

<script>
/**
 * This file is called Modal because of existing html element 'dialog'
 */
import IconButton from "@/components/IconButton.vue";
import CloseIcon from "@/assets/icons/close.svg";

export default {
  components: {
    IconButton,
    CloseIcon
  },
  props: {
    value: {
      type: Boolean,
      default: false
    },
    centerButtons: {
      type: Boolean,
      default: false
    }
  },
  methods: {
    onInput(value) {
      this.$emit("input", value);
    },
    onClose() {
      this.$emit("input", false);
    }
  }
};
</script>

<style lang="less">
@import "../assets/styles/_responsive.less";
@import "../assets/styles/_variables.less";

.close-button {
  position: absolute;
  top: 15px;
  right: 15px;
}

.dialog-wrapper {
  background-color: @white;
  display: flex;
  border-radius: 13px;
}

.dialog {
  margin: auto;
  position: relative;
  width: 100%;
  padding-top: 20px;
}

.dialog-content {
  text-align: center;
  padding: 10px 20px 30px 20px;

  .md({padding: 10px 85px 30px 85px;});
}
.dialog-footer {
  display: flex;
  justify-content: space-between;
  flex-direction: column;
  padding: 15px 30px;
  border-top: 1px solid @light-charcoal;
  &--center {
    justify-content: center;
  }
  .sm({padding: 32px 150px;});
  .md({padding: 30px 60px; flex-direction: row;});
  > .btn {
    // .sm-and-down(
    //   {margin: 10px 0;
    //   &: first-of-type {order: 2;} &: last-of-type {order: 1;}}
    // ) !important;
  }
}
</style>
